import { HIDE_CALLING_WIDGET } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageHideWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: HIDE_CALLING_WIDGET,
      data
    });
  }
}